import {useCallback} from 'react';
import {useModal} from 'extensions/viewport/useModal';
import {ModalWebUpload} from 'interface/stacks/ModalWebUpload';

export function useModalWebUpload(id: string, url?: string) {
  const modal = useModal();
  const open = useCallback(() => {
    modal.open(
      <ModalWebUpload {...{id, url, exit: modal.exit}}/>
    );
  }, [id, url]);
  return {open, exit: modal.exit};
}
